<template>
    <div class="wrap">
      <div class="container">
        <!-- <van-swipe :autoplay="3000" indicator-color="#000000">
                  <van-swipe-item v-for="(value, index) in banner_list" :key="index">
                      <router-link :to="value.event_type == 0 ? value.event_value : ''" v-if="value.images_url !=''">
                          <img width="100%" v-lazy="value.images_url" :title="value.banner_name" />
                      </router-link>
                  </van-swipe-item>
              </van-swipe> -->
        <!-- <van-tabs v-model="active" @click="changeTab(active)" color="#000000">
          <van-tab
            v-for="(item, index) in nav_header"
            :key="index"
            :title="item.name"
          ></van-tab>
        </van-tabs>
        <div class="itemTabs" v-if="active!=0">
          <div v-for="(item, index) in category_list" :key="index" class="itemTabs_box" @click="searchGoods(item.value,index)">
            <img src="https://www.jqxtech.com/static/upload/images/goods/2024/12/25/1735116032309338.jpg" class="itemTabs_img" :class="{'itemTabs_imgShow':itemTabsShow==index}" />
            <div class="itemTabs_text" :class="{'itemTabs_textShow':itemTabsShow==index}">{{item.text}}</div>
          </div>
        </div> -->
        <!-- <van-dropdown-menu active-color="#000000">
          <van-dropdown-item
            v-model="category_id"
            :options="category_list"
            @change="searchGoods"
          />
          <van-dropdown-item
            v-model="screening_price_id"
            :options="screening_price_list"
            @change="searchGoods"
          />
        </van-dropdown-menu> -->
        <div class="list_goodsbox f-clearfix">
          <van-list
            v-model="loading"
            loading-text="加载中..."
            :finished="finished"
            finished-text=""
            @load="getData()"
          >
            <div
              class="iteam_googds f-clearfix"
              v-for="(value, index) in goods_list"
              :key="index"
            >
              <div class="gl_iterm">
                <router-link
                  class="shopimg_wrap"
                  :to="{ path: 'details', query: { id: value.id } }"
                >
                  <van-image
                    class="goods_images"
                    :src="value.home_recommended_images"
                  >
                    <template v-slot:loading>
                      <van-loading type="spinner" size="20" />
                    </template>
                  </van-image>
                  <div class="diszk" v-if="value.discount_show_text > 0">
                    <p>{{ value.discount_show_text }}%</p>
                    <p>OFF</p>
                  </div>
                </router-link>
                <div class="outer_con">
                  <div class="goods_title">
                    <router-link
                      :to="{ path: 'details', query: { id: value.id } }"
                      >{{ value.title }}</router-link
                    >
                  </div>
                  <div class="goods_price">
                    <!-- <s>￥{{ value.min_original_price }}</s> -->
                    ￥{{ value.min_price }}
                  </div>
                  <!-- <van-row type="flex" align="center" justify="center">
                    <div class="goods_star">
                      <van-rate
                        v-model="value.start"
                        :size="12"
                        color="#f73184"
                        readonly
                      />
                    </div>
                    <font> 评论({{ value.comments }})</font>
                  </van-row> -->
                </div>
              </div>
            </div>
          </van-list>
          <van-empty description="没有更多了..." v-if="goods_list.length < 1" />
        </div>
      </div>
      <v-foot></v-foot>
    </div>
  </template>
  <script>
  export default {
    components: {},
    data() {
      return {
        pl_star: 3,
        value1: 0,
        value2: "a",
        value3: "a",
        category_id: 0,
        keywords: "",
        page: 1,
        screening_price_id: 0,
        category_list: [],
        screening_price_list: [],
        goods_list: [],
        loading: false,
        finished: false,
        flag: true,
        nav_header: [],
        banner_list: [],
        active: 0,
        itemTabsShow: 0
      };
    },
    created() {
      this.getNav();
      // this.getTab()
      if (this.$route.query.id !== undefined) {
        this.category_id = this.$route.query.id;
      }
      if (this.$route.query.keywords !== undefined) {
        this.keywords = this.$route.query.keywords;
      }
    },
    watch: {
      $route: {
        handler() {
          this.category_id = this.$route.query.id;
          this.keywords = this.$route.query.keywords;
          this.searchData();
          //深度监听，同时也可监听到param参数变化
        },
        deep: true,
      },
    },
    methods: {
      getNav() {
        var _self = this;
        this.GET("/nav", function (data) {
          if (data.code == 0) {
            window.nav_header = data.data.header;
            _self.nav_header = data.data.header;
            window.nav_footer = data.data.footer;
            _self.cart_total = data.data.cart_total;
          }
        });
      },
      getData() {
        if (this.flag) {
          this.flag = false;
          var data = {
            category_id: this.category_id,
            keywords: this.keywords,
            page: this.page,
          };
          if (this.screening_price_id > 0) {
            data.screening_price_id = this.screening_price_id;
          }
          var url = "api/search/index";
          var _self = this;
  
          this.loading = true;
          this.POST(url, data, function (ret) {
            if (ret.code === 0) {
              _self.category_list = ret.data.category;
              _self.screening_price_list = ret.data.screening_price_list;
              if (_self.goods_list.length === 0) {
                _self.goods_list = ret.data.data;
              } else {
                _self.goods_list = _self.goods_list.concat(ret.data.data);
              }
              _self.finished = !ret.data.next_page;
              _self.page = ret.data.page;
            }
            _self.flag = true;
            _self.loading = false;
          });
        }
      },
      getTab() {
        var url = "/api/v1/index";
        var _self = this;
        this.GET(url,{},function (data) {
          if(data.code == 0){
            _self.banner_list 	= data.data.banner_list;
            // _self.hot_goods 	= data.data.goods_hot;
            // _self.new_goods 	= data.data.goods_new;
            // _self.price_symbol 	= data.data.price_symbol;
          }
        })
      },
      searchData(){
        this.goods_list = [];
        this.page = 1;
        this.getData();
      },
      searchGoods(value,index) {
        console.log('value',value)
        this.itemTabsShow = index
        if(value) this.category_id = value
        this.goods_list = [];
        this.page = 1;
        this.getData();
      },
      changeTab(index) {
        if(!index) index = 0
        console.log('商品分类：',index)
        let id = this.nav_header[index].value || 0
        console.log('商品id：',id)
        this.category_id = id || 0
        this.goods_list = [];
        this.page = 1;
        this.itemTabsShow = 0
        this.getData();
      }
    },
  };
  </script>